import styled from 'styled-components';
import { Layout, Typography, Button, Table, Spin } from 'antd';

import colors from '../../styles/colors';

const { Text } = Typography;

const { Content } = Layout;

export const PageSpin = styled(Spin)`
  width: 100%;
`;

export const Page = styled.div`
  width: 100%;
  min-height: calc(100vh - 65px);
  display: flex;
  flex-direction: column;
`;

export const Wrapper = styled(Content)`
  width: 100%;
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  padding: 14px 15px 16px 13px;
  box-sizing: border-box;
`;

export const AttendanceHeader = styled.div`
  flex: 0 0 auto;
  min-height: 72px;
  display: grid;
  grid-template-columns: minmax(240px, 1fr) minmax(320px, 500px);
  gap: 24px;
  align-items: center;
  padding: 12px 39px 12px 38px;
  box-sizing: border-box;
  border-bottom: 1px solid #e5e5e5;
  background: #fff;

  @media (max-width: 800px) {
    grid-template-columns: minmax(0, 1fr);
    gap: 10px;
  }
`;

export const DivProgress = styled.div`
  width: 100%;
  min-width: 0;
`;

export const Title = styled(Text)`
  color: ${props => props?.color || colors.greyText};
  font-size: ${props => props?.size || 18}px;
  /* font-weight: ${props => (props?.weight ? 'bold' : 'normal')}; */
  font-weight: bold;
  line-height: ${props => props?.line || 21}px;
  > span {
    font-weight: bold;
  }
`;

export const ButtonCustom = styled(Button)`
  height: ${props => (props.bCsv ? 45 : 50)}px;
  width: ${props => (props.bCsv ? 150 : 170)}px;
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
  border: none;
  color: ${colors.branco} !important;
  background: ${props => props.background || '#24A95D'} !important;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
`;

export const CardTabs = styled.div`
  margin-top: 16px;
  width: 100%;
  min-width: 0;
  display: flex;
  flex: 1;

  .ant-tabs {
    width: 100%;
    min-width: 0;
    display: flex;
    flex: 1;

    .ant-tabs-content-holder {
      min-width: 0;
      display: flex;
      flex: 1;
      background: #fff;
      border-radius: 4px;
    }

    .ant-tabs-content {
      width: 100%;
      min-height: 100%;
      background: #fff;
      border: none;

      .ant-tabs-tabpane-active {
        min-height: 100%;
      }

      div::-webkit-scrollbar {
        width: 8px;
        border-radius: 20px;
        border: none;
      }

      div::-webkit-scrollbar-track {
        background: #f4f4f4;
        border-radius: 20px;
      }
      div::-webkit-scrollbar-thumb {
        background-color: #bdbdbd;
        border-radius: 20px;
      }
    }
  }
  .ant-tabs-nav-list {
    margin-left: 15px;
  }
  .ant-tabs-nav {
    margin: 0;
    .ant-tabs-tab {
      background: #fff;
      color: #707070;
      font-size: 14px;
      line-height: 22px;
    }
    .ant-tabs-tab-active {
      background: #24a95d;
      font-size: 14px;
      line-height: 22px;
      color: #707070;
      .ant-tabs-tab-btn {
        color: #707070;
      }
      .ant-tabs-tab-remove {
        color: #707070;
      }
    }
    th.ant-table-cell {
      height: 100%;
      background: #fff;
      border-bottom: 2px solid #cacaca;
      text-align: center;
    }
  }
`;

export const TabsColumn = styled.div`
  min-width: 0;
  display: flex;
`;

export const TabContent = styled.div`
  min-width: 0;
  min-height: 100%;
  padding: 0 6px 16px 16px;
  box-sizing: border-box;
  border-radius: 2px;
  background: #fff;

  &.consultas {
    padding-top: 30px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 16px;
`;

export const ContainerFilter = styled.div`
  width: 100%;
  margin: 20px 0;
  .ant-input-affix-wrapper,
  .ant-input-affix-wrapper-lg {
    background-color: ${colors.gbGrey};
    padding: 12px 9px;
    border: none;
    .ant-input-prefix {
      color: ${colors.verde};
      margin-left: 8px;
    }
    input {
      background-color: ${colors.gbGrey};
      font-size: 14px;
      font-weight: 20px;
      color: ${colors.greyText};
      margin-left: 8px;
    }
  }
`;

export const ContainerTable = styled.div`
  width: 100%;
`;

export const TableCustom = styled(Table)`
  .ant-table-thead ::before {
    display: none;
  }
  .ant-table-thead > tr > th {
    border-bottom: 2px solid #cacaca;
    background-color: ${colors.branco};
    color: ${colors.greyText};
  }
  .ant-table table {
    padding-right: 6px;
  }
  .ant-table-tbody > tr > td {
    border-bottom: none;
    font-size: 14px;
    color: #828282;
    padding: 6px;
  }
  .ant-table-cell-scrollbar {
    display: none;
  }
`;

export const ContainerConsultas = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
  align-items: stretch;
  flex: 1 0 auto;
  padding: 0;

  @media (max-width: 1100px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const ContentConsultas = styled(Content)`
  margin-bottom: 16px;
`;

export const BlocoCustonRealtorio = styled(Content)`
  border: none;
  background: #ffffff;
  padding: 10px 17px 10px 17px;
  border-radius: 4px;
`;
